@if (internalValue() && internalValue().length > 0) {
    <div class="st-staff-id-list__container">
        @for (idx of indexes(); track idx) {
            @if (internalValue()[idx]) {
                <st-avatar
                    medium
                    class="st-staff-id-list-value"
                    matTooltipPosition="above"
                    [matTooltip]="getName(internalValue()[idx])"
                    [userId]="internalValue()[idx]">
                    {{ getItemInitials(internalValue()[idx]) }}
                </st-avatar>
            }
        }
        @if (shouldShowExtraStaff()) {
            <div
                #triggerOverlay="cdkOverlayOrigin"
                class="st-staff-id-list-value__plus"
                cdkOverlayOrigin
                (mouseenter)="showStaffTooltip()"
                (mouseleave)="onMouseOut($event)">
                +{{ extraStaffCount() }}
            </div>
            <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="triggerOverlay"
                [cdkConnectedOverlayOpen]="isListOpen()"
                (attach)="panelAttached()">
                <st-staff-id-list-tooltip [users]="tooltipUsers()" />
            </ng-template>
        }
    </div>
}

@if (shouldShowAddButton()) {
    @if (hasButtonLabel()) {
        <button
            mat-button
            class="st-staff-id-list-button-add"
            [matMenuTriggerFor]="listDropDownMenu"
            [disabled]="disabled()"
            [class.st-staff-id-list-button-add-valid]="(required() && internalValue() && internalValue()?.length === 0) || !internalValue()"
            [class.st-staff-id-list-button-add-required]="required()"
            (menuClosed)="valueChanged()"
            (menuOpened)="onMenuOpened()">
            <mat-icon> person_add </mat-icon>
            {{ addButtonLabel() }}
        </button>
    } @else {
        <button
            mat-icon-button
            class="st-staff-id-list-button-add"
            [matMenuTriggerFor]="listDropDownMenu"
            [disabled]="disabled()"
            [class.st-staff-id-list-button-add-valid]="(required() && internalValue() && internalValue()?.length === 0) || !internalValue()"
            [class.st-staff-id-list-button-add-required]="required()"
            (menuClosed)="valueChanged()"
            (menuOpened)="onMenuOpened()">
            <mat-icon> person_add </mat-icon>
        </button>
    }
}

<mat-menu
    #listDropDownMenu="matMenu"
    class="st-staff-id-list-menu">
    <mat-chip-grid
        #chipGrid
        st-click-stop-propagation>
        @for (user of internalValue(); track user) {
            <mat-chip-row
                matChip
                (keydown.space)="remove(user)"
                (removed)="remove(user)">
                <st-avatar
                    small
                    matChipAvatar
                    [userId]="user" />
                {{ getName(user) }}
                <button matChipRemove>
                    <mat-icon>close</mat-icon>
                </button>
            </mat-chip-row>
        }
    </mat-chip-grid>
    <form
        st-click-stop-propagation
        [dir]="dir">
        <mat-form-field
            appearance="fill"
            subscriptSizing="dynamic"
            class="st-staff-id-list-form-field">
            <mat-icon matPrefix>search</mat-icon>
            <input
                #searchBox
                type="text"
                matInput
                [placeholder]="searchLabel()"
                [matChipInputFor]="chipGrid"
                [formControl]="staffFilter"
                (keydown.arrowup)="onUpArrowPress()"
                (keydown.arrowdown)="onDownArrowPress()"
                (matChipInputTokenEnd)="add($event)" />
        </mat-form-field>
        <mat-selection-list
            hideSingleSelectionIndicator
            st-click-stop-propagation
            multiple="false"
            [ngModel]="internalValue()"
            (selectionChange)="selected($event)">
            @for (userId of filteredOptions | async; track $index) {
                <mat-list-option
                    class="st-staff-id-list-menu-option"
                    [value]="userId">
                    <div class="st-staff-id-list-menu-option-info">
                        <st-avatar
                            class="st-staff-id-list-menu-option-info-avatar"
                            big
                            [userId]="userId" />
                        <div class="st-staff-id-list-menu-option-info-labels">
                            <span class="st-staff-id-list-menu-option-info-labels__title"> {{ getName(userId) }} </span>
                            <span class="st-staff-id-list-menu-option-info-labels__subtitle"> {{ getUserInfo(userId) }} </span>
                        </div>
                    </div>
                </mat-list-option>
            }
        </mat-selection-list>
    </form>
</mat-menu>
